"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upsertArticle = exports.generateHtml = void 0;
var reconnect_js_1 = require("reconnect.js");
var serializeToHtml_1 = __importDefault(require("../RichTextEditor/serializeToHtml"));
var Ant = __importStar(require("antd"));
var JStorage = __importStar(require("../../Actions/JStorage"));
var ActionOutlet = reconnect_js_1.getOutlet('actions');
function generateHtml(content) {
  return __awaiter(this, void 0, void 0, function () {
    var result, err_1;
    var _this = this;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!Array.isArray(content)) return [3 /*break*/, 4];
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3,, 4]);
          return [4 /*yield*/, Promise.all(content.map(function (n) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, serializeToHtml_1.default(n)];
                  case 1:
                    return [2 /*return*/, _a.sent()];
                }
              });
            });
          }))];
        case 2:
          result = _a.sent();
          return [2 /*return*/, result.join('')];
        case 3:
          err_1 = _a.sent();
          console.warn('轉換HTML失敗');
          return [3 /*break*/, 4];
        case 4:
          return [2 /*return*/, ''];
      }
    });
  });
}
exports.generateHtml = generateHtml;
function upsertArticle(record, document, options) {
  if (options === void 0) {
    options = {};
  }
  return __awaiter(this, void 0, void 0, function () {
    var _a, collectionName, _b, primaryKey, _c, token, _d, onUpdate, _e, onClose, createdDoc, ex_1;
    var _f;
    return __generator(this, function (_g) {
      switch (_g.label) {
        case 0:
          _a = options.collectionName, collectionName = _a === void 0 ? 'Article_Default' : _a, _b = options.primaryKey, primaryKey = _b === void 0 ? 'id' : _b, _c = options.token, token = _c === void 0 ? '' : _c, _d = options.onUpdate, onUpdate = _d === void 0 ? function () {} : _d, _e = options.onClose, onClose = _e === void 0 ? function () {} : _e;
          ActionOutlet.getValue().setLoading(true);
          _g.label = 1;
        case 1:
          _g.trys.push([1, 6,, 7]);
          createdDoc = void 0;
          if (!document) return [3 /*break*/, 3];
          return [4 /*yield*/, JStorage.updateDocument(collectionName, (_f = {}, _f[primaryKey] = document[primaryKey], _f), record, {
            token: token
          })];
        case 2:
          // edit
          createdDoc = _g.sent();
          Ant.message.success('編輯成功');
          return [3 /*break*/, 5];
        case 3:
          return [4 /*yield*/, JStorage.createDocument(collectionName, record, {
            token: token
          })];
        case 4:
          createdDoc = _g.sent();
          Ant.message.success('新增成功');
          _g.label = 5;
        case 5:
          onUpdate(createdDoc);
          onClose();
          return [3 /*break*/, 7];
        case 6:
          ex_1 = _g.sent();
          console.warn(ex_1);
          Ant.message.error('發生錯誤');
          return [3 /*break*/, 7];
        case 7:
          ActionOutlet.getValue().setLoading(false);
          return [2 /*return*/];
      }
    });
  });
}
exports.upsertArticle = upsertArticle;